export default __webpack_public_path__ + "static/media/sharezone.5f9ace6d.png";